// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__dkkiZ","status":"style_status__SVnCV","report":"style_report__2vMt7","actions":"style_actions__mWFGl","actions_btn":"style_actions_btn__Jatlr"};